import { Device } from '@cirqll/sdk/enum';

/**
 * Touch-first devices (coarse pointer, or iPadOS Safari posing as a Mac) are a tablet or
 * phone by their screen's shortest side; everything else is a desktop. Uses the screen
 * rather than the viewport, so resizing or rotating doesn't change the answer.
 */
export function useDevice(): Device {
    const is_touch = matchMedia('(pointer: coarse)').matches
        || /Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1;

    if (!is_touch) {
        return Device.DESKTOP;
    }

    return Math.min(screen.width, screen.height) >= 600 ? Device.TABLET : Device.MOBILE;
}
